export default [
  {
    title: 'ข้อมูลผู้ใช้งาน',
    route: 'userManagement',
    icon: 'UserIcon',
    action: 'all',
    resource: 'admin',
  },
]
